import { render, staticRenderFns } from "./InsufficientBalanceModal.vue?vue&type=template&id=054e75b1&scoped=true"
import script from "./InsufficientBalanceModal.vue?vue&type=script&lang=js"
export * from "./InsufficientBalanceModal.vue?vue&type=script&lang=js"
import style0 from "./InsufficientBalanceModal.vue?vue&type=style&index=0&id=054e75b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054e75b1",
  null
  
)

export default component.exports